import { motion } from 'framer-motion'

const StatsSection = () => {
  const stats = [
    { number: '+500 mil', label: 'Pontos Registrados' },
    { number: '+50 mil', label: 'Trabalhadores Impactados' },
    { number: '+1.000', label: 'Empresas Atendidas' }
  ]

  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-primary opacity-95" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-8 border-2 border-white/20 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2"
            >
              <p className="text-5xl md:text-6xl font-extrabold text-white mb-3">
                {stat.number}
              </p>
              <p className="text-xl text-white/90 font-semibold">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default StatsSection
